import dayjs from "dayjs";

export const dateToPrettyString = (date) => {
  return dayjs(date).format("dddd D MMMM YYYY");
};

export const dateObjectToString = (date) => {
  return dayjs(date).format("YYYY-MM-DD");
};
